import React from 'react';
import styleClasses from './css/MusicardPopup.module.scss';

const QRCode = ({ image, name }) => {
  return (
    (
      <div className={ styleClasses.qrWrap }>
        <img src={ image } alt={`${ name }'s QR Code`} />
      </div>
    )
  );
};

export default QRCode;
